import initialState from './initialState';
import * as actionTypes from '../constants/actionTypes';

export default function roulette(state = initialState.roulette, action) {
  switch (action.type) {
    case actionTypes.OPEN_REWARDS_GRID:
      return {...state, isModalShown: true};

    case actionTypes.CLOSE_REWARDS_GRID:
      return {...state, isModalShown: false};

    case actionTypes.SHOW_ROULETTE:
      return {...state, isRouletteShown: true};

    case actionTypes.CLOSE_ROULETTE:
      return {...state, isRouletteShown: false};

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/rouletteReducer.js
 **/